module.exports = __webpack_public_path__ + "static/media/28-1.3c23e8da.mp3";